export default function setData(ref, data = {}, merge = true) {
	return ref.set(data, { merge });
}
